import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ContentChild, Optional} from "@angular/core";
import {SearchFormExtendedFieldsComponent} from "./extended-fields/search-form-extended-fields.component";
import {SearchFormExtendedService} from "./search-form-extended.service";
import {
    FUIFilterFormContext,
    FUIFormContext,
    FUIStackedPageContextService,
    FUIStackedPageService
} from "@fedeltapointofsale/ui";
import {LocalisationPageComponent} from "../../../../localisation/localisation-page/localisation-page.component";
import {
    LocalisationPageStackedParams
} from "../../../../localisation/localisation-page/localisation-page-stacked-params";
import {Config} from "../../../../config";
import {AnalyticsService} from "../../../../analytics/analytics.service";
import {AnalyticEvent} from "../../../../analytics/analytic-event";
import {AbstractSearchModel} from "@fedeltapointofsale/data-client";

/**
 * Search form
 */
@Component({
    selector: "wbo-search-form",
    styleUrls: ["./search-form.component.scss"],
    templateUrl: "./search-form.component.html",
    providers: [{provide: FUIFormContext, useClass: FUIFilterFormContext}],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFormComponent {
    private static readonly SELECTED_OUTLETS_FILTER = "LOCALISATION_SELECTED_OUTLETS";
    private static readonly SELECTED_CUSTOM_OBJECTS_FILTER = "LOCALISATION_SELECTED_CUSTOM_OBJECTS";
    @ContentChild(SearchFormExtendedFieldsComponent) searchExtended: SearchFormExtendedFieldsComponent;

    LOCALISATION = Config.LOCALISATION;

    public localiseFiltersSelected: boolean = false;

    constructor(public searchModel: AbstractSearchModel,
                private changeDetectorRef: ChangeDetectorRef,
                public searchFormExtendedService: SearchFormExtendedService,
                private stackedPageService: FUIStackedPageService,
                private analyticsService: AnalyticsService,
                @Optional() private stackedPageContextService: FUIStackedPageContextService) {
    }

    confirmLocalisation(localisationPageStackedParams: LocalisationPageStackedParams): void {
        const filter: any = {};
        filter[SearchFormComponent.SELECTED_OUTLETS_FILTER] = localisationPageStackedParams.selectedOutlets;
        filter[SearchFormComponent.SELECTED_CUSTOM_OBJECTS_FILTER] = localisationPageStackedParams.selectedCustomObjects;
        this.searchModel.setFilterValues(filter);
        this.localiseFiltersSelected = (this.searchModel.filter[SearchFormComponent.SELECTED_OUTLETS_FILTER] !== undefined &&
            this.searchModel.filter[SearchFormComponent.SELECTED_OUTLETS_FILTER].length > 0)
            || (this.searchModel.filter[SearchFormComponent.SELECTED_CUSTOM_OBJECTS_FILTER] !== undefined &&
                this.searchModel.filter[SearchFormComponent.SELECTED_CUSTOM_OBJECTS_FILTER].length > 0);

        if (this.localiseFiltersSelected) {
            this.analyticsService.trackEvent(AnalyticEvent.SEARCH_LOCALISATION_FILTER_UPDATED, this.searchModel);
        }
        this.changeDetectorRef.markForCheck();
    }

    openLocalisationDialog(): void {
        this.analyticsService.trackEvent(AnalyticEvent.SEARCH_LOCALISATION_FILTER_OPEN, this.searchModel);
        this.stackedPageService.open(LocalisationPageComponent, new LocalisationPageStackedParams(false, this.searchModel.filter[SearchFormComponent.SELECTED_OUTLETS_FILTER],
            this.searchModel.filter[SearchFormComponent.SELECTED_CUSTOM_OBJECTS_FILTER]))
            .subscribe((localisationPageStackedParams: LocalisationPageStackedParams) => this.confirmLocalisation(localisationPageStackedParams));
    }

    setSelectedFormFields(value: Array<string>): void {
        this.searchFormExtendedService.selectedFormFields = value;
    }
}
